export const isTestEnv = () => {
  const host = window.location.hostname;
  return (
    host === "localhost" ||
    host === "127.0.0.1" ||
    host.endsWith(".syon.jp") || // 例: test.syon.jp, mypage.syon.jp
    host.includes("test")        // 例: test-env.local
  );
};
